<template>
    <div v-if="showInfoModal">
        <b-modal v-model="showInfoModal"
                 :content-class=" 'custom-modal ' + (settings.sectionClass ? settings.sectionClass : '')">
            <template v-slot:modal-header="{ close }">
                <span class="close-icon" @click="onClose"></span>
            </template>

            <!-- :style="{ backgroundImage: 'url(' + require(`@/assets/icons/${settings.icon}`) + ')' }" -->
            <div class="modal-icon" v-if="settings.icon" :style="getIconStyle()"></div>
            <h2 class="modal-title">{{translate('own_DownloadSticker')}}</h2>
            <div class="modal-message">{{translate('own_StickerProportion')}}</div>
            <div v-if="settings.secondaryMessage" class="modal-secondary-text">{{ settings.secondaryMessage }}</div>

           
           <div v-if="settings.popapButton" class="popapButton-wrapper">
               <div :class="{active: settings.format == 'default_with_hints'}" @click="onClick('default_with_hints')"
                    class="popapButton-panel"
                    id="Extended">
                   <div class="modal-panelIcon__extended" v-if="settings.panelExtendedIcon"
                        :style="getExtendedPanelIcon()"></div>
                   <div class="modal-textWrapper">
                       <div class="modal-panelText">{{translate('own_PanelTextExtended')}}</div>
                       <div class="modal-panelSubtitle">{{translate('own_PanelSubtitleExtended')}}</div>
                   </div>
               </div>
               <div :class="{active: settings.format == 'business_card'}" @click="onClick('business_card')"
                    class="popapButton-panel"
                    id="Leaflet">
                   <div class="modal-panelIcon" v-if="settings.panelLeafletIcon" :style="getLeafletPanelIcon()"></div>
                   <div class="modal-textWrapper">
                       <div class="modal-panelText">{{translate('own_PanelTextLeaflet')}}</div>
                       <div class="modal-panelSubtitle">{{translate('own_PanelSubtitleLeaflet')}}</div>
                   </div>
               </div>
               <div :class="{active: settings.format == 'signature_for_email'}" @click="onClick('signature_for_email')"
                    class="popapButton-panel"
                    id="signature_for_email">
                    <div class="signature__wrapper">
                        <div class="signature-text__wrapper">
                            <div class="signature-title">{{translate('emailSignature')}}</div>
                            <div class="signature-subtitle">{{translate('emailSignatureSubtitle')}}</div>
                            <div class="signature-copy__link" @click="signatureCopyLinkClick()">{{translate('emailSignatureCopyLink')}}</div>
                        </div>
                        <input type="hidden" text="fake" id="fake_input" value="fake"/>
                        <div class="signature">
                            <div id="own_signature" ref="ownSignature">
                                <table border="0" cellspacing="0" cellpadding="0" align="center">
                                    <tr>
                                        <td colspan="3" style="font-size:13px; text-align: center; padding-bottom: 4px;">
                                            <b>{{settings.question.text || settings.text}}</b>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td align="right">
                                            <a :href="`${location.origin}/r/rate/` + settings.question.uid + '/3'" style="mso-line-height-rule: exactly;-ms-text-size-adjust: 100%;-webkit-text-size-adjust: 100%;color: #007C89;font-weight: normal;text-decoration: underline;">
                                                <img align="none" alt="Happy" data-file-id="5484253" height="51" src="https://mcusercontent.com/b92973fb598e2f78aeedb5437/images/b8cb1880-0bf5-6b86-5161-2a246b8105cf.png" style="border: 0px;width: 50px;height: 51px;margin: 0px;outline: none;text-decoration: none;-ms-interpolation-mode: bicubic;" width="50">
                                            </a>
                                        </td>
                                        <td width="80" align="center">
                                            <a :href="`${location.origin}/r/rate/` + settings.question.uid + '/2'" style="mso-line-height-rule: exactly;-ms-text-size-adjust: 100%;-webkit-text-size-adjust: 100%;color: #007C89;font-weight: normal;text-decoration: underline;">
                                                <img alt="So-So" data-file-id="5484257" height="51" src="https://mcusercontent.com/b92973fb598e2f78aeedb5437/images/ee813e56-d00e-4ec6-1094-00b27f476708.png" style="border: 0px initial;width: 50px;height: 51px;margin: 0px;outline: none;text-decoration: none;-ms-interpolation-mode: bicubic;" width="50">
                                            </a>
                                        </td>
                                        <td align="left">
                                            <a :href="`${location.origin}/r/rate/` + settings.question.uid + '/1'" style="mso-line-height-rule: exactly;-ms-text-size-adjust: 100%;-webkit-text-size-adjust: 100%;color: #007C89;font-weight: normal;text-decoration: underline;">
                                                <img alt="Sad" data-file-id="5484261" height="51" src="https://mcusercontent.com/b92973fb598e2f78aeedb5437/images/bdbfc823-92b8-6967-0456-f924be344449.png" style="border: 0px initial;width: 50px;height: 51px;margin: 0px;outline: none;text-decoration: none;-ms-interpolation-mode: bicubic;" width="50">
                                            </a>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colspan="3" style="font-size: 10px; color: black; text-align: center">
                                            <b>{{translate('emailSignatureClick')}}</b>
                                        </td>
                                    </tr>
                                </table>
                            </div>
                        </div>
                        <div class="signature-copy__link_mobile" @click="signatureCopyLinkClick()">{{translate('emailSignatureCopyLink')}}</div>
                    </div>
               </div>

<!--               <div id="own_signature" ref="ownSignature" style="display: none">-->
<!--                   <div style="text-align: left;"><span style="font-size:13px">How’s AirVote working for you so far?</span><br>-->
<!--                       <a href="https://my.air-vote.com/r/rate/8e815066-9702-49dc-8176-e766c147d13e/3" style="mso-line-height-rule: exactly;-ms-text-size-adjust: 100%;-webkit-text-size-adjust: 100%;color: #007C89;font-weight: normal;text-decoration: underline;"><img align="none" alt="Happy" data-file-id="5484253" height="51" src="https://mcusercontent.com/b92973fb598e2f78aeedb5437/images/b8cb1880-0bf5-6b86-5161-2a246b8105cf.png" style="border: 0px;width: 50px;height: 51px;margin: 0px;outline: none;text-decoration: none;-ms-interpolation-mode: bicubic;" width="50"></a>&nbsp; &nbsp;<a href="https://my.air-vote.com/r/rate/8e815066-9702-49dc-8176-e766c147d13e/2" style="mso-line-height-rule: exactly;-ms-text-size-adjust: 100%;-webkit-text-size-adjust: 100%;color: #007C89;font-weight: normal;text-decoration: underline;"><img alt="So-So" data-file-id="5484257" height="51" src="https://mcusercontent.com/b92973fb598e2f78aeedb5437/images/ee813e56-d00e-4ec6-1094-00b27f476708.png" style="border: 0px initial;width: 50px;height: 51px;margin: 0px;outline: none;text-decoration: none;-ms-interpolation-mode: bicubic;" width="50"></a>&nbsp; &nbsp;<a href="https://my.air-vote.com/r/rate/8e815066-9702-49dc-8176-e766c147d13e/1" style="mso-line-height-rule: exactly;-ms-text-size-adjust: 100%;-webkit-text-size-adjust: 100%;color: #007C89;font-weight: normal;text-decoration: underline;"><img alt="Sad" data-file-id="5484261" height="51" src="https://mcusercontent.com/b92973fb598e2f78aeedb5437/images/bdbfc823-92b8-6967-0456-f924be344449.png" style="border: 0px initial;width: 50px;height: 51px;margin: 0px;outline: none;text-decoration: none;-ms-interpolation-mode: bicubic;" width="50"></a></div>-->
<!--               </div>-->

<!--               <div :class="{active: settings.format == 'business_card'}" @click="onClick('business_card')"-->
<!--                    class="popapButton-panel"-->
<!--                    id="Business">-->
<!--                   <div class="modal-panelIcon__business" v-if="settings.panelBusinessIcon"-->
<!--                        :style="getBusinassPanelIcon()"></div>-->
<!--                   <div class="modal-textWrapper">-->
<!--                       <div class="modal-panelText">{{translate('own_PanelTextBusiness')}}</div>-->
<!--                       <div class="modal-panelSubtitle">{{translate('own_PanelSubtitleBusiness')}}</div>-->
<!--                   </div>-->
<!--               </div>-->
           </div>


            <template v-slot:modal-footer>
                <div class="footerButton__wrapper">
                    <a v-if="settings.showCancelButton" class="cancel__btn" @click="onClose">
                        <template v-if="settings.cancelButtonText">{{ settings.cancelButtonText }}</template>
                        <template v-else>{{ translate('Cancel') }}</template>
                    </a>

                    <b-button v-if="settings.showAdditionalButton" variant="success" class="btn-primary"
                              @click="onAdditional">
                        <template v-if="settings.additionalButtonText">{{ settings.additionalButtonText }}</template>
                        <template v-else>Additional</template>
                    </b-button>

                    <a v-if="!settings.hideOkButton && settings.format !== 'signature_for_email'" class="onOk__btn" @click="onOk">
                        <div v-if="settings.windowWidthCheck">
                            <template>{{translate('own_DownloadPDFMobile')}}</template>
                        </div>
                        <div v-else>
                            <template>{{translate('own_DownloadPDF')}}</template>
                        </div>
                    </a>
                    <a v-if="settings.format == 'signature_for_email'" class="onOk__btn" @click="copySignatureBtnClick(getElementById())">
                        <div>
                            <template>{{translate('copy')}}</template>
                        </div>
                        <div class="tooltip__content" :class="{'show': copiedFlag}">
                            {{translate('copied')}}
                        </div>
                    </a>

                </div>

            </template>

        </b-modal>
    </div>
</template>

<script>
    import _ from "lodash";
    import errorMixin from '@/mixins/errorMixin';
    import singleEmailSignaturePage from '@/components/widgets/singleEmailSignaturePage';
    import config from '@/api/config';

    export default {
        name: 'customModalPopap',

        mixins: [errorMixin],

        data() {
            return {
                showInfoModal: !_.isEmpty(this.settings),
                copiedFlag: false,
                location: location,
            }
        },

        watch: {
            settings(newValue) {
                this.showInfoModal = !_.isEmpty(newValue)
            }
        },

        props: {
            settings: {
                type: [Object, null],
                default: () => {
                    return {
                        windowWidth: null,
                    }
                }
            },
        },


        methods: {
            getElementById() {
               return this.$refs.ownSignature.innerHTML
            },

            getIconStyle() {
                if (this.settings.icon) {
                    return {
                        backgroundImage: 'url(' + require(`@/assets/icons/${this.settings.icon}`) + ')'
                    }
                } else {
                    return null
                }
            },
            getLeafletPanelIcon() {
                 if (this.settings.icon) {
                    return {
                        backgroundImage: 'url(' + require(`@/assets/images/${this.settings.panelLeafletIcon}`) + ')'
                    }
                } else {
                    return null
                }
            },
            getBusinassPanelIcon() {
                 if (this.settings.icon) {
                    return {
                        backgroundImage: 'url(' + require(`@/assets/images/${this.settings.panelBusinessIcon}`) + ')'
                    }
                } else {
                    return null
                }
            },
            getExtendedPanelIcon() {
                if (this.settings.icon) {
                    return {
                        backgroundImage: 'url(' + require(`@/assets/images/${this.settings.panelExtendedIcon}`) + ')'
                    }
                } else {
                    return null
                }
            },


            async onClose() {
                this.showInfoModal = false
                if (this.settings.onCancelHandler) {
                    try {
                        await this.settings.onCancelHandler(this.settings)
                    } catch (error) {
                        this.showErrorModal(error.message)
                    }
                }
            },

            async onOk() {
                this.showInfoModal = false
                if (this.settings.onOkHandler) {
                    try {
                        await this.settings.onOkHandler(this.settings)
                    } catch (error) {
                        this.showErrorModal(error.message)
                    }
                }
            },

            onAdditional() {
                this.showInfoModal = false
                if (this.settings.onAdditionalHandler) {
                    this.settings.onAdditionalHandler(this.settings)
                }
            },
            onClick(format) {
                this.settings.format = format
                console.log(this.settings)
            },
            copySignatureBtnClick(str) {
                this.copiedFlag = true
                setTimeout(()=>{
                    this.copiedFlag = false
                }, 1000)
                function listener(e) {
                    e.preventDefault();
                    e.clipboardData.setData("text/html", str);
                    e.clipboardData.setData("text/plain", str);
                }
                document.addEventListener("copy", listener);
                let item = document.getElementById('fake_input')
                let oldType = item.type
                let hidden = oldType == 'hidden'
                if(hidden) item.type = 'text'
                item.select()
                item.setSelectionRange(0, 99999);
                document.execCommand("copy");
                if(hidden) item.type = 'hidden'
                document.removeEventListener("copy", listener);
            },
            signatureCopyLinkClick() {
                let url = `${location.origin}/questions/${this.settings.question.uid}/e-signature/?q=${encodeURI(this.settings.question.text)}`
                let item = document.getElementById('fake_input')
                item.value = url
                let oldType = item.type
                let hidden = oldType == 'hidden'
                if(hidden) item.type = 'text'
                item.select()
                item.setSelectionRange(0, 99999);
                document.execCommand("copy");
                if(hidden) item.type = 'hidden'
                this.setMessageModel({
                    msg: this.translate('manageCopiedToClipboard'),
                    duration: 1000
                })
            }

        },
    }
</script>

<style>

    .modal-secondary-text {
        font-size: 12px;
        font-weight: 700;
        margin-top: 15px;
    }
    .popapButton-wrapper {
        display: flex;
        justify-content: space-between;
        padding: 13px 0 0 15px;
        flex-direction: column;
    }
    .popapButton-panel {
        height: auto !important;
        padding: 24px 32px 16px 32px;
        background-color: #F7F7F7;
        cursor: pointer;
        margin-bottom: 16px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .popapButton-panel.active {
        border: 4px solid #2F2F2F;
        border-radius: 3.33px;
        padding: 20px 28px 12px 28px;

    }

    .modal-panelIcon {
        height: 80px;
        width: 160px;
        background-repeat: no-repeat;
        background-size: 100%;
        margin-bottom: 24px;
        transition: 0.2s linear;
        margin-top: 15px;
    }
    .modal-panelIcon__business {
        height: 97px;
        width: 158px;
        border-radius: 2.22px;
        background-repeat: no-repeat;
        background-size: 100%;
    }
    .modal-panelIcon__extended {
        height: 104px;
        width: 160px;
        border-radius: 4px;
        background-repeat: no-repeat;
        background-size: 100%;
    }
    .modal-panelText {
        font-weight: 700;
    }
    .modal-panelSubtitle {
        width: 344px;
        color: #2F2F2F;
        font-family: Nunito;
        font-weight: 500;
        font-size: 14px;
        letter-spacing: 0;
        line-height: 20px;
    }
    .modal-textWrapper {
        text-align: start;
        padding-left: 25px;
    }
    @media screen and (max-width: 426px) {
        .popapButton-wrapper {
            display: flex;
            align-items: center;
            flex-direction: column;
            padding: 13px 0 0 64px
        }

        .popapButton-panel {
           margin-bottom: 12px;
        }


    }
    

    .custom-modal.leftAlign .modal-input {
        text-align: left;
    }

    .custom-modal .close-icon {
        position: static;
        cursor: pointer;
        width: 28px;
        height: 28px;
        background: url('../../assets/icons/ic_close_white.svg') 50% no-repeat;
    }

    .custom-modal .modal-title {
        font-size: 18px;
        font-weight: bold;
        color: #2F2F2F;
        text-align: center;
    }

    .custom-modal .modal-header {
        text-align: center;
        border: none;
        justify-content: flex-end;
        padding-bottom: 0;
    }

    .custom-modal.welcome-modal .modal-footer {
        flex-direction: column;
    }

    .custom-modal.welcome-modal .modal-footer > * {
        width: 100%;
        margin: 5px 0;
        text-decoration: none;
    }

    .custom-modal .modal-footer a {
        text-decoration: none;
    }

    .custom-modal .modal-footer {
        border: none;
    }

    .custom-modal .modal-message {
        width: 448px;
        color: #2F2F2F;
        font-family: Nunito;
        font-size: 16px;
        letter-spacing: 0;
        line-height: 24px;
    }

    .custom-modal {
        text-align: center;
        width: 640px;
    }

    .modal-input {
        margin-top: 15px;
    }

    .modal-input input:focus {
        border-color: #2F2F2F;
        box-shadow: 0 0 0 0.2rem rgba(47, 47, 47, 0.25);
    }

    .custom-modal .btn {
        min-width: 140px;
        padding: 10px 12px;
        border-radius: 0;
        border: none;
        font-size: 14px;
        font-weight: bold;
        width: 100%;
    }

    .custom-modal .modal-icon {
        width: 56px;
        height: 56px;
        margin: 0 auto;
        background-size: cover;
        margin-bottom: 15px;
    }
    .custom-modal .popapButton-icon {
        height: 96px;
        background-size: cover;
    }

    .custom-modal .btn.btn-primary {
        background: #2F2F2F;
        color: #ffffff;
    }
    .footerButton__wrapper {
        display: flex;
        width: 100%;
    }
    .onOk__btn {
        position: relative;
        width: 100%;
        color: #FFFFFF !important;
        font-family: Nunito;
        font-size: 16px;
        font-weight: 700;
        letter-spacing: 0;
        line-height: 24px;
        border-radius: 6px;
        background-color: #3F405C;
        text-align: center;
        padding-top: 11px;
        cursor: pointer;
        height: 48px
    }
    .cancel__btn {
        width: 100%;
        padding-top: 11px;
        cursor: pointer;
        border: 2px solid #3F405C;
        border-radius: 6px;
        color: #3F405C;
        font-family: Nunito;
        font-size: 16px;
        font-weight: 700;
        letter-spacing: 0;
        line-height: 24px;
        margin-right: 16px;
    }
    
    
    /**/
    .full-width--btn.large {
        min-width: 40vw;
        font-size: 0.7vw;
        transform: translateX(-50%);
        left: 50%;
    }

    .full-width--btn.large.custom-modal .modal-message {
        width: 90%;
    }

    .full-width--btn.custom-modal .btn {
        width: 100%;
    }
    .signature-title {
        width: 256px;
    }
    .signature-subtitle {
        color: #2F2F2F;
        font-family: Nunito;
        font-weight: 500;
        font-size: 14px;
        letter-spacing: 0;
        line-height: 20px;
        width: 250px;
    }
    .signature {
        pointer-events: none;
        padding-right: 23px;
        text-align: center;
        display: flex;
        justify-content: center;
    }
    .signature__wrapper {
        display: flex;
        flex-direction: row-reverse;
        align-items: center;
    }
    .signature-copy__link {
        color: #007bff  !important;
        font-family: Nunito;
        font-size: 16px;
        font-weight: 700;
        letter-spacing: 0;
        line-height: 24px;
        border-radius: 6px;
        text-align: start;
        margin-top: 5px;

    }
    .signature-copy__link_mobile {
        display: none;
        margin-top: 8px;
        margin-bottom: 8px;
    }
    .signature-text__wrapper {
        text-align: start;
    }
    .tooltip__content {
        right: 110px;
        top: -40px;
        background: forestgreen;
        border-radius: 2px;
        -webkit-box-shadow: 0 3px 1px -2px rgba(0,0,0,.2), 0 2px 2px 0 rgba(0,0,0,.14), 0 1px 5px 0 rgba(0,0,0,.12);
        box-shadow: 0 3px 1px -2px rgba(0,0,0,.2), 0 2px 2px 0 rgba(0,0,0,.14), 0 1px 5px 0 rgba(0,0,0,.12);
        color: #fff;
        display: inline-block;
        font-size: 12px;
        padding: 5px 8px;
        position: absolute;
        -webkit-transition: 0.2s;
        transition: 0.2s;
        width: auto;
        opacity:0;
    }
    .tooltip__content.show {
        opacity:1;
        transition: 1s;
        -webkit-transition: 0.2s;
        transition: 0.2s;
    }
    @media screen and (max-width: 1024px) {
        .custom-modal {
            width: 600px;
        }
        .popapButton-panel {
            width: 530px;
        }
        .modal-panelIcon {
            margin-top: 32px;
        }
        .modal-panelIcon__extended {
            margin-top: 15px;
        }
        .modal-panelIcon__business {
            margin-top: 15px;
        }
        .signature__wrapper {
            margin-left: 0px;
        }
    }
    @media screen and (max-width: 1000px) {
        .full-width--btn.custom-modal .modal-footer button {
            width: 100%;
            margin: 0;
            margin-top: 3vw;
        }

        .full-width--btn.custom-modal .modal-footer {
            border: none;
            flex-direction: column-reverse;
            /* width: 100%; */
        }
    }
    @media screen and (max-width: 768px) {
        .custom-modal {
            width: 550px;
        }
        .popapButton-panel {
            width: 480px;
        }
        .popapButton-panel {
            padding: 14px 8px 8px 9px;
        }
        .popapButton-panel.active {
            padding: 10px 4px 4px 5px;
        }
        .modal-textWrapper {
            padding-left: 5px;
        }
        .modal-panelIcon {
            margin-top: 45px;
        }
        .modal-panelIcon__extended {
            margin-top: 25px;
        }
        .modal-panelIcon__business {
            margin-top: 23px;
        }
    }
    @media screen and (max-width: 426px) {
        .custom-modal {
            width: auto;
        }
        .signature-copy__link {
            display: none;
        }
        .signature-copy__link_mobile {
            display: block;
            color: #007bff;
        }
        .modal-panelSubtitle {
            display: none;
        }
        .popapButton-panel {
            width: auto;
            display: flex;
            flex-direction: column;
            height: auto;
        }
        .popapButton-wrapper {
            padding: 13px 0 0 0;
        }
        .modal-panelIcon {
            margin-top: 0;
            margin-bottom: 15px;
        }
        .modal-panelIcon__extended {
            margin-top: 0;
            margin-bottom: 15px;
        }
        .modal-panelIcon__business {
            margin-top: 0;
            margin-bottom: 15px;
        }
        .signature {
            padding-right: 0;
        }
        .signature-title {
            padding-right: 0;
            padding-bottom: 10px;
            text-align: center;
        }
        .signature-subtitle {
            display: none;
        }
        .signature__wrapper {
            flex-direction: column;
        }
    }
</style>